/**
 * ProjectApiClient -- HTTP client for /api/v1/Projects.
 *
 * @module infrastructure/api/ProjectApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/Projects';

export const ProjectApiClient = {
  async list(page = 1, pageSize = 20, status = null, projectType = null) {
    const params = new URLSearchParams({ page, pageSize });
    if (status)      params.set('status', status);
    if (projectType) params.set('projectType', projectType);
    return ApiBase.get(`${BASE}?${params}`);
  },

  async getById(id) {
    return ApiBase.get(`${BASE}/${id}`);
  },

  async getByKey(key) {
    return ApiBase.get(`${BASE}/by-key/${key}`);
  },

  /**
   * Actualiza campos de un proyecto por project_key (patch semántico: null = no modificar).
   * Endpoint real expuesto por NexoAPI: PUT /api/v1/Projects/by-key/{key}.
   *
   * @param {string} key   - p.ej. 'nexo-desktop'
   * @param {object} data  - Subset de UpdateProjectRequest:
   *                         description, goals, operationalStatus, status,
   *                         technologies, progressPercent, statusMetadata
   */
  async updateByKey(key, data) {
    return ApiBase.put(`${BASE}/by-key/${encodeURIComponent(key)}`, data);
  },
};
